/**
 * GENERATED_ASSET — render tokens copied from the canonical catalog
 * `docs/plans/2026-10-20-hush-nook-lanternskip/catalog/render-tokens.json` (revision hush-palette-style.1),
 * which is identical to the batch001 kit's `recipes/render-tokens.json`. A JSON import from docs/ would leave
 * this project's `rootDir`, so the values live here; hushStatic.test.ts compares them to the catalog file.
 * The catalog's prose `rules` are not consumed by construction and are not copied.
 */
import type { Tokens } from './contracts';
import { LEGACY_PIECE_PALETTES } from '../pieces/legacyPalettes';

export const HUSH_RENDER_TOKENS: Tokens = {
  revision: 'hush-palette-style.1',
  palettes: LEGACY_PIECE_PALETTES,
  style: {
    outerStroke: 2.1, seamStroke: 1.2, grainStroke: 0.65, grainOpacity: 0.14,
    contactShadowOpacity: 0.18, coordinatePrecision: 3, samplingPadding: 2,
  },
  detailTiers: {
    readable: { grainMarks: 0, minorRepairs: false },
    standard: { grainMarks: 8, minorRepairs: true },
    close: { grainMarks: 14, minorRepairs: true },
  },
  masterMotif: {
    id: 'hush.two_over_one.v1',
    centers: [{ x: -12, y: -56 }, { x: 12, y: -56 }, { x: 0, y: -32 }],
    radius: 7.5,
    protectedRadius: 10,
    randomization: 'forbidden',
  },
};
